<template>
  <div class="transaction-history">
    <div class="offers-top">
      <div class="right">
        <div class="header">My offers</div>
        <button class="button red" @click="openSaleSkinModal">
          NEW OFFER
        </button>
      </div>
    </div>
    <div class="transaction-history__content">
      <div class="transaction-history__table-wrapper">
        <table class="transaction-history__table">
          <thead>
            <tr>
              <th>{{ $t('ID') }}</th>
              <th>{{ $t('Date') }}</th>
              <th>{{ $t('Skin name') }}</th>
              <th>{{ $t('Status') }}</th>
              <th>{{ $t('Total') }}</th>
              <th>{{ $t('Details') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="offerLoading" class="transaction-history__loading-row">
              <td colspan="6">
                <Spinner />
              </td>
            </tr>
            <tr v-else-if="offerHistory.length === 0" class="transaction-history__no-data-row">
              <td colspan="6">{{ $t('No data found') }}</td>
            </tr>
            <tr v-else v-for="(item, i) in offerHistory" :key="i">
              <td>{{ item.id }}</td>
              <td>{{ formatDate(item.date_time) }}</td>
              <td>{{ item.title }}</td>
              <td :class="statusClass(item.status)">
                <span class="status">{{ formatStatus(item.status) }}</span>
              </td>
              <td class="desc">
                <b>{{ item.service_price || item.user_price }} {{ item.currency }}</b>
              </td>
              <td>
                <a v-if="item.status != 'ready_for_payout'" class="offer-modal-open desc link"
                  @click="openOfferDetails(item)">
                  <b>View</b>
                </a>
                <a class="offer-modal-open desc link" v-if="item.status == 'ready_for_payout'"
                  @click="openAcceptOffer(item)">
                  <b>Withdraw</b>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <SaleSkinModal v-if="saleSkinModalVisible" />
    <OfferDetailsModal v-if="offerDetailsModalVisible" :orderToView="selectedOffer" />
    <AcceptOfferModal v-if="acceptOfferModalVisible" :orderToView="selectedOffer" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Spinner from '@/components/shared/Spinner.vue';
import SaleSkinModal from '@/components/modals/SaleSkinModal.vue';
import OfferDetailsModal from '@/components/modals/OfferDetailsModal.vue';
import AcceptOfferModal from '@/components/modals/AcceptOfferModal.vue';

export default {
  name: "MyOffers",
  props: ['isOfferEnabled'],
  components: {
    Spinner,
    SaleSkinModal,
    OfferDetailsModal,
    AcceptOfferModal,
  },
  computed: {
    ...mapState('offer', ['offerHistory', 'offerLoading', 'selectedOffer']),
    ...mapState('modals', ['saleSkinModalVisible', 'offerDetailsModalVisible', 'acceptOfferModalVisible']),
  },
  methods: {
    ...mapActions('offer', ['getOfferHistory']),
    ...mapActions('modals', ['openSaleSkinModal', 'openOfferDetailsModal', 'openAcceptOfferModal']),
    formatDate(num) {
      let objectDate = new Date(num * 1000);
      let day = objectDate.getDate();
      if (day < 10) {
        day = '0' + day;
      }
      let month = objectDate.getMonth() + 1;
      if (month < 10) {
        month = `0${month}`;
      }
      let year = objectDate.getFullYear();

      function padTo2Digits(x) {
        return String(x).padStart(2, '0');
      }
      let hoursAndMinutes = padTo2Digits(objectDate.getHours()) + ':' + padTo2Digits(objectDate.getMinutes());
      let format = day + "." + month + "." + year + ' ' + hoursAndMinutes;

      return format
    },
    formatStatus(status) {
      if (!status) return "";
      return status.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
    },
    openOfferDetails(item) {
      this.openOfferDetailsModal(item);
    },
    openAcceptOffer(item) {
      if (!item || !item.id) {
        this.$toast.error('Invalid offer data. Missing required ID.');
        return;
      }
      this.openAcceptOfferModal(item);
    },
    statusClass(status) {
      switch (status) {
        case "approved":
        case "ready_for_payout":
          return "success";
        case "declined_by_user":
        case "declined_by_service":
          return "error";
        default:
          return "";
      }
    },
  },
 watch: {
    isOfferEnabled(newValue) {
      if (newValue === false) {
        this.$router.replace({ name: 'Profile', query: { tab: 'transactions' } });
      }
    }
  },
  mounted() {
    if (this.isOfferEnabled === false) {
        this.$router.replace({ name: 'Profile', query: { tab: 'transactions' } });
    }
    this.getOfferHistory();
  }
};
</script>

<style lang="scss" scoped>
.offers-top {
  .right {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }

  .header {
    text-transform: uppercase;
    font-size: 18px;
    font-weight: 700;
    color: #fff;
  }
}
</style>